import React from "react";
import { useStaticQuery, graphql } from "gatsby";

import { usePersistedParams } from "../hooks/usePersistedParams";

export function Seo({
  description,
  title,
  image,
  imageAlt,
  location,
  children
}) {
  usePersistedParams();

  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            siteUrl
            twitterUsername
            image
          }
        }
      }
    `
  );

  const siteUrl = site.siteMetadata.siteUrl;

  const metaTitle =
    title && title.length
      ? `${title} | ${site.siteMetadata.title}`
      : site.siteMetadata.title;

  const metaDescription = description || site.siteMetadata.description;

  const defaultImage = `${siteUrl}${site.siteMetadata.image}`;

  const metaImage = image
    ? ensureFullUrl(image, siteUrl)
    : defaultImage;

  const metaUrl = `${siteUrl}${location?.pathname ?? ""}`;

  return (
    <>
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="og:url" content={metaUrl} />
      <meta name="og:title" content={metaTitle} />
      <meta name="og:image" content={metaImage} />
      <meta name="og:description" content={metaDescription} />
      <meta name="og:type" content={`website`} />
      <meta name="twitter:card" content={`summary_large_image`} />
      <meta name="twitter:image" content={metaImage} />
      {imageAlt && <meta name="twitter:image:alt" content={imageAlt} />}
      <meta
        property="twitter:domain"
        content={siteUrl.replace("https://")}
      />
      <meta property="twitter:url" content={metaUrl} />

      <meta
        name="twitter:site"
        content={site.siteMetadata.twitterUsername}
      />
      <meta
        name="twitter:creator"
        content={site.siteMetadata.twitterUsername}
      />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={metaDescription} />
      <script
        id="ze-snippet"
        src="https://static.zdassets.com/ekr/snippet.js?key=5a971480-a46e-4ff6-bf24-850d170c1c3d"
      ></script>
      <script
        type="text/javascript"
        src="https://af.uppromote.com/tracking_third_party.js?shop=neurosity.myshopify.com"
      ></script>
      {children}
    </>
  );
}

function ensureFullUrl(string, siteUrl) {
  if (siteUrl && string && string.indexOf("http") !== 0) {
    return `${siteUrl}${string}`;
  }

  return string;
}
